import { InjectionToken } from '@angular/core'
import { IdentityConfig } from 'identity-services'

export const identityConfigToken = new InjectionToken<IdentityConfig>(
  'IdentityConfigToken',
)
